import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import { useStore } from "utils/useStore";
import { ApplicationFiltersStore } from "stores/ApplicationFilters/ApplicationFiltersStore";
import React from "react";
import { DateReferenceOption } from "stores/ComponentStores/DatePickerComponentStore";

const dateReferenceOptionLabel: Record<DateReferenceOption, string> = {
    [DateReferenceOption.InteractionDate]: "Interaction Date",
    [DateReferenceOption.ArrivalDate]: "Arrival Date",
    [DateReferenceOption.EvaluationCompleteDate]: "Evaluation Complete Date",
    [DateReferenceOption.EvaluationStartDate]: "Evaluation Start Date",
    [DateReferenceOption.CreatedOnDate]: "Created On Date",
};

export const DateReferenceChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const globalApplicationFiltersStore = useStore(ApplicationFiltersStore);
    const applicationFiltersStore = props.store ?? globalApplicationFiltersStore;
    const chipValue = props.store
        ? applicationFiltersStore.dateReferenceOption
        : globalApplicationFiltersStore.quickFiltersStore.dateReferenceOption;

    const label =
        dateReferenceOptionLabel[chipValue as DateReferenceOption] ??
        chipValue;

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() => {
                if (!props.store) {
                    globalApplicationFiltersStore.quickFiltersStore.setDateReferenceOption(
                        DateReferenceOption.InteractionDate,
                    );
                }
                applicationFiltersStore.setDateReferenceOption(
                    DateReferenceOption.InteractionDate,
                );
            }}
        >
            {label}
        </AppliedFilterChip>
    );
});
